import styled from 'styled-components';
import { ReactComponent as PinIcon } from '../../../assets/pin-icon.svg';
import { TextLabel } from '../../../common/typography/typography.styles';

export const LightPinIcon = styled(PinIcon).attrs({
  viewBox: '0 0 20 20',
  focusable: false,
})`
  width: 16px;
  height: 16px;
  display: inline-block;
  overflow: visible;
  flex: 0 0 16px;
  margin-right: 0.4rem;
  & path {
    fill: #75777b;
  }
`;

export const PinLabel = styled(TextLabel)`
  font-weight: 400;
  font-size: 1.4rem;
  color: #75777b;
`;
